import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import { CheckIcon, CrossIcon, DownloadIcon } from '../../../assets/icons/icons';
import { useTelegram } from '../../../assets/hooks/useTelegram';
import { requestTelegramFileDownload } from '../../../assets/utils/telegramFileDownload';
import BottomSheet from '../../shared/BottomSheet/BottomSheet';
import './ExportReady.css';

function ExportReady() {
  const navigate = useNavigate();
  const location = useLocation();
  const { common, history } = useContext(TranslationContext);
  const { webApp } = useTelegram();
  const exportFile = location.state?.exportFile || {};
  const fileName = exportFile.fileName || exportFile.file_name || 'sandrapay-transactions.csv';
  const fileUrl = exportFile.url || exportFile.fileUrl || exportFile.file_url || '';

  const handleClose = () => {
    if (location.state?.backgroundLocation) {
      navigate(-1);
      return;
    }

    navigate('/history', { replace: true });
  };

  const handleDownload = async () => {
    if (!fileUrl) {
      toast.error(history.downloadMissing);
      return;
    }

    try {
      const isNativeDownload = await requestTelegramFileDownload({
        url: fileUrl,
        fileName,
        webApp,
      });

      toast(isNativeDownload ? history.downloadStarted : history.downloadOpened, {
        autoClose: 1600,
        className: 'app-toast app-toast--copy',
      });
    } catch (error) {
      toast.error(error?.message || history.downloadFailed);
    }
  };

  return (
    <BottomSheet
      className="export-ready"
      panelClassName="export-ready__panel"
      titleId="export-ready-title"
      onClose={handleClose}
    >
      <header className="export-ready__header">
        <h2 id="export-ready-title" className="export-ready__heading">
          {history.exportTitle}
        </h2>
        <button
          type="button"
          className="export-ready__close"
          aria-label={common.close}
          onClick={handleClose}
        >
          <CrossIcon className="export-ready__close-icon" />
        </button>
      </header>

      <div className="export-ready__hero">
        <div className="export-ready__badge" aria-hidden="true">
          <CheckIcon className="export-ready__badge-icon" />
        </div>
        <h3 className="export-ready__title">{history.exportReady}</h3>
        <p className="export-ready__text">{history.exportReadyText}</p>
      </div>

      <div className="export-ready__file">
        <div className="export-ready__file-icon">CSV</div>
        <div className="export-ready__file-copy">
          <span className="export-ready__file-name">{fileName}</span>
        </div>
      </div>

      <button type="button" className="export-ready__download" onClick={handleDownload}>
        <DownloadIcon className="export-ready__download-icon" />
        {history.downloadFile}
      </button>
    </BottomSheet>
  );
}

export default ExportReady;
